webpackJsonp([35783957827783],{

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/code.a54e611c.jpg";

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fov_visualiser.17a2f736.png";

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactstrap = __webpack_require__(40);
	
	var _code = __webpack_require__(454);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _wintersenseCslMounting = __webpack_require__(456);
	
	var _wintersenseCslMounting2 = _interopRequireDefault(_wintersenseCslMounting);
	
	var _fov_visualiser = __webpack_require__(455);
	
	var _fov_visualiser2 = _interopRequireDefault(_fov_visualiser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocsListing = function DocsListing() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactstrap.Container,
	      null,
	      _react2.default.createElement(
	        _reactstrap.Row,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { sm: '12', lg: '6' },
	          _react2.default.createElement(
	            _reactstrap.Card,
	            { className: 'my-2' },
	            _react2.default.createElement(_reactstrap.CardImg, { top: true, width: '100%', src: _code2.default, alt: 'Code' }),
	            _react2.default.createElement(
	              _reactstrap.CardBody,
	              null,
	              _react2.default.createElement(
	                _reactstrap.CardTitle,
	                null,
	                'How to use the API'
	              ),
	              _react2.default.createElement(
	                _reactstrap.CardText,
	                null,
	                'The Wintersense API provides numerous HTTPS endpoints for accessing data collected by your Networks. This is great way to pull data into your own application.'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://docs.wintersense.com/api/v1', className: 'btn btn-primary' },
	                'API Docs'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { sm: '12', lg: '6' },
	          _react2.default.createElement(
	            _reactstrap.Card,
	            { className: 'my-2' },
	            _react2.default.createElement(_reactstrap.CardImg, { top: true, width: '100%', src: _wintersenseCslMounting2.default, alt: 'Wintersense Mounting' }),
	            _react2.default.createElement(
	              _reactstrap.CardBody,
	              null,
	              _react2.default.createElement(
	                _reactstrap.CardTitle,
	                null,
	                'Installing a Sensor'
	              ),
	              _react2.default.createElement(
	                _reactstrap.CardText,
	                null,
	                'Need to know where and how to install a Wintersense Road Temperature sensor? Our guide explains all.'
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/installation', className: 'btn btn-primary' },
	                'Installation Guide'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { sm: '12', lg: '6' },
	          _react2.default.createElement(
	            _reactstrap.Card,
	            { className: 'my-2' },
	            _react2.default.createElement(_reactstrap.CardImg, { top: true, width: '100%', src: _fov_visualiser2.default, alt: 'Field of View Visualiser' }),
	            _react2.default.createElement(
	              _reactstrap.CardBody,
	              null,
	              _react2.default.createElement(
	                _reactstrap.CardTitle,
	                null,
	                'Field of View Visualiser'
	              ),
	              _react2.default.createElement(
	                _reactstrap.CardText,
	                null,
	                'Assess if a site is suitable for a Wintersense sensor using this interactive tool.'
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/field-of-view', className: 'btn btn-primary' },
	                'Try it out'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_reactstrap.Col, { sm: '12', lg: '6' })
	      )
	    )
	  );
	};
	
	exports.default = DocsListing;
	module.exports = exports['default'];

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wintersense-csl-mounting.e82c759b.jpg";

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WinterJumbo = function (_React$Component) {
	  _inherits(WinterJumbo, _React$Component);
	
	  function WinterJumbo() {
	    _classCallCheck(this, WinterJumbo);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WinterJumbo.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#00BFF3',
	          padding: '15px',
	          textAlign: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'h1',
	        {
	          style: {
	            marginBottom: '0'
	          }
	        },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'p',
	        {
	          style: {
	            marginBottom: '0'
	          }
	        },
	        this.props.subtitle
	      )
	    );
	  };
	
	  return WinterJumbo;
	}(_react2.default.Component);
	
	// Prop types are a feature for runtime validation of props during development.
	
	
	WinterJumbo.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = WinterJumbo;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _WinterJumbo = __webpack_require__(41);
	
	var _WinterJumbo2 = _interopRequireDefault(_WinterJumbo);
	
	var _DocsListing = __webpack_require__(199);
	
	var _DocsListing2 = _interopRequireDefault(_DocsListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_WinterJumbo2.default, {
	      title: 'Wintersense Docs'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(_DocsListing2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f2aa6230094417dafb3d.js